<template>
  <section hidden="true">
    <h2>Skills and Technologies</h2>
    <p>List the programming languages, frameworks, and tools you are proficient in.</p>
    <p>Include any certifications or courses you've completed.</p>
  </section>
</template>

<script>
export default {
  name: 'SkillsSection'
}
</script>

<style scoped>
section {
  max-width: 950px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 8px;
  color: var(--white-ish);
}

h2 {
  margin-top: 0;
  text-align: center;
}

p {
  margin: 10px 0;
  text-align: center;
}
</style>